import type { ThemeKey } from '@/types/content';

export const themeText: Record<ThemeKey, string> = {
  primary: 'text-primary-600',
  accent: 'text-accent-600',
  secondary: 'text-secondary-600',
};

export const themeTextStrong: Record<ThemeKey, string> = {
  primary: 'text-primary-700',
  accent: 'text-accent-700',
  secondary: 'text-secondary-700',
};

export const themeSoft: Record<ThemeKey, string> = {
  primary: 'bg-primary-100 text-primary-800',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export const themeBorder: Record<ThemeKey, string> = {
  primary: 'border-primary-300',
  accent: 'border-accent-300',
  secondary: 'border-secondary-300',
};

export const themeDot: Record<ThemeKey, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};